import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchOverlayService {
  private _showOverlay = signal(false);

  showOverlay = this._showOverlay.asReadonly();

  showSearchOverlay(): void {
    this._showOverlay.set(true);
  }

  hideOverlay(): void {
    this._showOverlay.set(false);
  }
}